import React, { useEffect } from 'react'
import { PageHeader, CustomPanel, CustomDropdown, ThreeDots } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import useListaEnvioEmailState, { ListaEnvioEmailActions } from './ListaEnvioEmailState'
import { tableCellCentered } from '../../../../assets/js/styles'
import ModalListaEnvioEmail from './ModalListaEnvioEmail'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

export default connect()(withRouter(ListaEnvioEmail))

function ListaEnvioEmail({ history, dispatch }) {
  // Hooks
  const {
    centraisOperacionais,
    centralSelecionada,
    listas,
    listaSelecionada,
    navigateToEmails,
    loading,
    erro,
    onCentralChange,
    onModalResponse,
    onMenuItemClicked,
    onBtnNovoClick,
    resetError,
  } = useListaEnvioEmailState()

  useEffect(() => {
    listaSelecionada &&
      navigateToEmails &&
      history.push('/main/cadastros/email', {
        lista_id: listaSelecionada.id,
        lista_nome: listaSelecionada.nome,
      })
  }, [navigateToEmails, listaSelecionada, history])

  useEffect(() => {
    switch (loading) {
      case ListaEnvioEmailActions.LOADING_LISTAS_ENVIO:
        dispatch(showLoadingBox('Carregando as Listas de Envio ...', 'Aguarde . . . '))
        break
      case ListaEnvioEmailActions.LOADING_NONE:
        dispatch(hideLoadingBox())
        break
      case ListaEnvioEmailActions.LOADING_SALVANDO_LISTA:
        dispatch(showLoadingBox('Salvando Lista de Envio ...', 'Aguarde . . . '))
        break
      case ListaEnvioEmailActions.EXCLUINDO_LISTA:
        dispatch(showLoadingBox('Excluindo a Lista de Envio ...', 'Aguarde . . . '))
        break
      default:
        break
    }
  }, [loading])

  useEffect(() => {
    erro && dispatch(showMessageBox(null, erro)) && resetError()
  }, [erro])

  // Render
  return (
    <>
      <PageHeader>2.7 - Lista de Envio - Emails</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovoClick} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                showLabel={true}
                label="Selecione Central de Operações"
                marginTop={0}
                optionLabel="name"
                options={centraisOperacionais}
                value={centralSelecionada}
                onChange={onCentralChange}
              />
            </div>
            <div className="p-col-12">
              <DataTable
                value={listas}
                emptyMessage="Não existe Lista de Envio de Email cadastrada"
              >
                <Column field="id" header="Código" style={tableCellCentered(70)} />
                <Column field="nome" header="Lista" />
                <Column field="qte_emails" header="Qte. Emails" style={tableCellCentered(150)} />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={lista => (
                    <ThreeDots
                      items={['Editar', 'Excluir', 'Emails']}
                      onClick={item => onMenuItemClicked(item, lista)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalListaEnvioEmail incomeLista={listaSelecionada} onResponse={onModalResponse} />
    </>
  )
}
